import * as React from 'react';
import * as ReactDOM from 'react-dom';
import Icons from '../../../../icons';
import { useDispatch, useSelector } from "react-redux";
const ClassNames=require('classnames');
import { writeNoteReview, editDraftNote, cloneSavedNoteToDraft, publishSavedNote, deleteSavedNote, updateNotesFileCaption} from '../../../../containers/WorkkardDetail/actions/action';
import ConfirmationTextBox from "../../../../components/ConfirmationPrompt";
import { CharConstants, StringConstants, MiddlePanelConstant } from '../../../../containers/WorkkardDetail/constants';
import { showDialogueBox, hideDialogueBox } from '../../../../components/DialogueBox/actions';
import { TOOLTIP_DELAY_TIME } from '../../../SpockViewPage/constants';
import { SHOW_TOOLTIP } from '../../../../components/Tooltip/constants';
import UserMiniProfile from '../../../../components/UserMiniProfile';
import FileView from '../../../../components/FileView';
import NoteResolution from './noteResolutionTemplate';
import NoteData from './noteDataTemplate';
import * as CommonUtil from '../../../../common/util';
import {NoteListingLoader} from '../../../../components/SkeletonLoader';
import UserImage from '../../../../components/UserImage';
import { selectSessionContextOidc } from '@container/AdminPanel/features/users/usersSelectors';

const NoteCell = (props) => {
    const dispatch = useDispatch();
    const activityDetail = useSelector(state => state.workkardDetail.activityDetail);
    const workkard = useSelector(state => state.workkardDetail.workkardDetail);
    const middlePanel = useSelector(state => state.workkardDetail.middlePanel);
    const galleryData = useSelector(state => state.workkardDetail.middlePanel.notes.galleryData);
    const isMiddlePanelLoading = useSelector(state => state.workkardDetail.middlePanel.isLoading);
    const refreshNoteId = useSelector(state => state.workkardDetail.middlePanel.notes.refreshNoteId);
    const sessionContext = useSelector(selectSessionContextOidc);
    const cachedUser = useSelector(state => state.userList?.[props.data?.CreatedBy]);
    const userView = sessionContext?.userView;
    const userPermission = userView?.permissions;

    const cachedUserFullName = cachedUser
        ? `${cachedUser.first_name || cachedUser.firstName || ''} ${cachedUser.last_name || cachedUser.lastName || ''}`.trim()
        : '';
    const avatarName = props.data?.Name || cachedUserFullName;
    const avatarUrl = props.data?.ProfileImage
        || cachedUser?.ProfileFullImage
        || cachedUser?.profile_image
        || cachedUser?.profile_picture
        || '';

    const onUpdateFileCaption = (payload) => dispatch(updateNotesFileCaption(payload));

    const [reviewId, setReviewId] = React.useState(null);
    const [deleteNoteId, setDeleteNoteId] = React.useState(0);

    const timeOutRef = React.useRef(null);

    /**
     * set reviewing note  id in state
     * @param {string } id note  id
     */
    const onReviewClick = (id) => {
        setReviewId(id);
    };

    /**
     * submit  note review and clear  state
     * @param {string} id note  id
     */
    const reviewSubmit = async (id, review) => {
        const payload = {
            id: id,
            activity_id: activityDetail.activityId,
            reason: review
        };
        await dispatch(writeNoteReview(payload));
        setReviewId(null);
    };

    /** hide dialog box */
    const onCancelPersonalNoteClick = () => {
        dispatch(hideDialogueBox());
    };


    const onPublishPersonalNoteClick = (type, id) => {
        let params = { nId: id, itemId: activityDetail.activityId, wkId: workkard.Id, publishType: type, templateType: middlePanel.notes.type.toLowerCase(), isDraftNote: true };
        dispatch(publishSavedNote(params));
        dispatch(hideDialogueBox());
    };


    const onPublishDraft = (id) => {
        return (
            <div className="publish-note-popup">
                <div className="publish-note-popup-wraper">
                    <div className="publish-note">
                        <ul className="publish-action">
                            <li>
                                <a id="closeActDraftNotePublishBtn" href="javascript:void(0);" onClick={onCancelPersonalNoteClick} className="close-publish-note fr">
                                    <Icons name="close" className="icon" />
                                </a>
                            </li>
                            {
                                ((middlePanel.notes.type.toLowerCase() == StringConstants.workkard && userPermission?.can_add_public_notes_workkard) || (middlePanel.notes.type.toLowerCase() == StringConstants.activity && userPermission?.can_add_public_notes_activity && activityDetail.status.toLowerCase() !== 'close')) &&
                                <li onClick={() => onPublishPersonalNoteClick(StringConstants.Public, id)}>
                                    <span className="move"></span>
                                    <a className="change_workkard_sponsor" href="javascript:void(0);" >
                                        <span className="public_icon"></span>
                                        <strong>{MiddlePanelConstant.Note.Public}</strong><br /> {MiddlePanelConstant.Note.PublishPublicText}
                                    </a>
                                </li>
                            }
                            {
                                ((middlePanel.notes.type.toLowerCase() == StringConstants.workkard && userPermission?.can_add_private_notes_workkard) || (middlePanel.notes.type.toLowerCase() == StringConstants.activity && userPermission?.can_add_private_notes_activity)) &&
                                <li onClick={() => onPublishPersonalNoteClick(StringConstants.Private, id)}>
                                    <span className="move"></span>
                                    <a className="create_activity" href="javascript:void(0);">
                                        <span className="community_icon"></span>
                                        <strong>{MiddlePanelConstant.Note.Internal}</strong><br /> {MiddlePanelConstant.Note.PublishInternal}
                                    </a>
                                </li>
                            }
                        </ul>
                    </div>
                </div>
            </div>
        );
    };


    const onPublishClick = (id, type) => {
        let params = {
            nId: id,
            itemId: activityDetail.activityId,
            wkId: workkard.Id,
            publishType: StringConstants.Public,
            templateType: middlePanel.notes.type.toLowerCase()
        };
        if (type.toLowerCase() == "internal") {
            dispatch(publishSavedNote(params));
        } else {
            dispatch(showDialogueBox({
                flag: true,
                component: onPublishDraft(id),
                overlayClassName: "modal",
                contentClassName: "modalContent small",
                shouldCloseOnOverlayClick: true
            }));
        }
    };

    /** delete  note confimation click */
    const onDeleteNoteConfirmClick = () => {
        if (deleteNoteId > 0) {
            var noteType = middlePanel.notes.type.toLowerCase() == StringConstants.activity ? CharConstants.Activity : CharConstants.Workkard;
            let params = { nId: deleteNoteId, itemId: activityDetail.activityId, type: noteType };
            dispatch(deleteSavedNote(params));
        }
        dispatch(hideDialogueBox());
    };

    /** delete note cancel click */
    const onDeleteNoteCancelClick = () => {
        setDeleteNoteId(0);
        dispatch(hideDialogueBox());
    };

    /** delete note open dialog box  */
    const onDeleteNoteClick = (id) => {
        if (CommonUtil.showWriteOffNotification() == "false") {
            setDeleteNoteId(id);
            dispatch(showDialogueBox({
                flag: true,
                component: <ConfirmationTextBox
                    class={"modalBody"}
                    message={MiddlePanelConstant.Note.DeleteNoteText}
                    onConfirmClick={onDeleteNoteConfirmClick}
                    onCancelClick={onDeleteNoteCancelClick}
                    confirmationText={"Confirm"}
                    footerClass={"modalFooter"}
                    cancelText={"Cancel"}
                />,
                overlayClassName: "modal",
                contentClassName: "modalContent small animated faster fadeInUpx2 confirmModal",
                shouldCloseOnOverlayClick: true
            }));
        }
    };


    // const onEditNoteClick = (id) => {
    //     if (CommonUtil.showWriteOffNotification() == "false") {
    //         var noteType = middlePanel.notes.type.toLowerCase() == StringConstants.activity ? CharConstants.Activity : CharConstants.Workkard;
    //         let params = { noteid: id, type: noteType };
    //         dispatch(editDraftNote(params));
    //     }
    // };


    const onCloneNoteClick = (id) => {
        if (CommonUtil.showWriteOffNotification() == "false") {
            var noteType = middlePanel.notes.type.toLowerCase() == StringConstants.activity ? CharConstants.Activity : CharConstants.Workkard;
            var typeId = middlePanel.notes.type.toLowerCase() == StringConstants.activity ? activityDetail.activityId : workkard.Id;
            let params = { noteid: id, type: noteType, tyid: typeId };
            dispatch(cloneSavedNoteToDraft(params));
        }
    };


    const renderResolutionTemplate = (data) => {
        return (
            <NoteResolution data={data} onPublishClick={onPublishClick} />
        );
    };


    const renderNoteDataTemplate = (data) => {
        return (
            <NoteData data={data} reviewId={reviewId} onReviewClick={onReviewClick} onPublishClick={onPublishClick} onDeleteNoteClick={onDeleteNoteClick} onCloneNoteClick={onCloneNoteClick} reviewSubmit={reviewSubmit} />
        );
    };


    const openMiniProfile = (targetRect) => {
        const userId = props.data.CreatedBy;
        if (userId) {
            dispatch({
                type: SHOW_TOOLTIP,
                payload: {
                    delay: TOOLTIP_DELAY_TIME,
                    target: targetRect,
                    childComponent: <UserMiniProfile userId={userId}/>,
                }
            });
        }
    };

    const onMouseEnter = (e) => {
        const targetRect = e.currentTarget.getBoundingClientRect();
        timeOutRef.current = setTimeout(() => openMiniProfile(targetRect), 500);
    };

    const onMouseLeave = () => {
        clearTimeout(timeOutRef.current);
    };

    const getDescription = (data) => {
        if (!sessionContext?.organizationView?.Id || !process.env.mercury_orgIds.split(",").includes(String(sessionContext.organizationView.Id))) {
            return (
                `<section class='noteDescriptionFormating InformationLetter editorNoteFormatting'>${data.Description}</section>`
            );
        } else {
            return data.Description;
        }
    };

    const { data, extraData } = props;
    const styleClass = {
        'noteRightBlock detailRightBlock': true,
        'resolutionChanged': (data.FromResolution != null && data.ToResolution != null) && (data.FromResolution != "" && data.ToResolution != ""),
    };

    const FileData = {
        Files: (
            data.ActivityNoteFiles && data.ActivityNoteFiles.length > 0 &&
            data.ActivityNoteFiles.map((file, fileKey) => {
                return (
                    Object.assign({}, file, { NoteCategory: data.NoteCategory }, { NoteId: data.Id })
                );
            })
        )
        ||
        (
            data.WorkkardFiles && data.WorkkardFiles.length > 0 &&
            data.WorkkardFiles.map((file, fileKey) => {
                return (
                    Object.assign({}, file, { NoteCategory: data.NoteCategory }, { NoteId: data.Id })
                );
            })
        )
    };

    return (
      <React.Fragment>
        {isMiddlePanelLoading && data.Id == refreshNoteId ? (
          <NoteListingLoader count={1} />
        ) : (
          <div
            className={`notesListing detailListing ${
              extraData &&
              extraData.map((item, key) => {
                if (item.Id == data.Id) {
                  return "animated slow fadeIn";
                }
                return "";
              })
            }`}
            key={data.Id}
          >

            {(data.FromResolution != null &&
            data.ToResolution != null &&
            data.FromResolution != "" &&
            data.ToResolution != "" && (
                <div className="notesCreatedDate detailCreatedDate">
                    <Icons
                    name="resolutionIcon"
                    className="icon profilePic resIcon"
                    />
                </div>
            )) ||
            (<div className="notesCreatedDate detailCreatedDate" onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} >
                <UserImage profileUrl={avatarUrl} className="profilePic" profileName={avatarName}/>
            </div>
            )}

            <div className={ClassNames(styleClass)}>
              <div className="notesDescription detailDescription">
                {(data.FromResolution != null &&
                  data.ToResolution != null &&
                  data.FromResolution != "" &&
                  data.ToResolution != "" &&
                  renderResolutionTemplate(data)) ||
                  renderNoteDataTemplate(data)}

                {data.Description &&
                    (
                        <React.Fragment>
                        <p className='noteEmailFormating' dangerouslySetInnerHTML={{ __html: getDescription(data) }}></p>
                         <style dangerouslySetInnerHTML={{__html: `
                        table, td {width: auto !important;}
                        table { min-width: 100%; line-height: 1.2}
                        hr {width: 100%;}
                        img {max-width:100% !important; height:auto !important;}
                    `   }} />

                        </React.Fragment>
                    )}
                {/* {data.Description &&
                    
                    <iframe 
                    style={{ width:'100%', height:this.state.iFrameHeight, overflow:'visible'}}
                    frameborder="0"
                    ref={this.myRef}
                    srcDoc = {`<div id = 'paraIframe' class='noteDescriptionFormating InformationLetter'>${data.Description}</div>`} 
                    scrolling='no'
                    width="100%"
                    onLoad = {this.resizeIframe}
                    height = {this.state.iFrameHeight}>
                    </iframe>
                        } */}

                {/* <p className="noteDescriptionFormating InformationLetter" dangerouslySetInnerHTML={{ __html: data.Description }}>
                           
                        </p> */}
              </div>

              <div className="fileAttachment">
                {FileData.Files != undefined ? (
                  <FileView
                    fileData={FileData}
                    updateFileCaption={onUpdateFileCaption}
                    galleryData={galleryData}
                    EditableMode={true}
                  />
                ) : null}
              </div>
            </div>
          </div>
        )}
      </React.Fragment>
    );
};

export default NoteCell;
